import UkRow from './src/uk-row';

/* istanbul ignore next */
UkRow.install = function(Vue) {
    Vue.component(UkRow.name, UkRow);
};

export default UkRow;


// WEBPACK FOOTER //
// ./packages/uk-row/index.js